import React, { FunctionComponent } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnpublishedIcon from '@mui/icons-material/Unpublished';

import {
  Chip,
  Grid
} from '@mui/material';

import { StyledButton } from '../../StyledButton';
import { Typography } from '../../Typography';

type SearchFilterStatusStringsProps = {
  values: [string, string][];
  filterValue: string[];
  setFilterValue: (z:string[]) => void;
  setEnterPressed?: (v:boolean) => void;
};

export const SearchFilterStatusStrings: FunctionComponent<SearchFilterStatusStringsProps> = ({values, filterValue, setFilterValue, setEnterPressed}) => {

  return (<>
    <Grid item xs={4} sx={{textAlign: 'right'}}>
      <Typography sx={{marginTop: 0.5}}>Filter</Typography>
    </Grid>
    <Grid item xs={8} sx={{textAlign: 'right'}}>
    {values.slice(0, 4).map(v => <>
      {/* <Grid item xs={2}> */}
        <Chip
          label={v[1]}
          variant={filterValue.indexOf(v[0]) > -1 ? "filled" : 'outlined'}
          icon={filterValue.indexOf(v[0]) > -1 ? <CheckCircleIcon /> : <UnpublishedIcon />}
          onClick={(vv) => {
            if (filterValue.indexOf(v[0]) > -1) {
              let old_arr = [...filterValue];
              old_arr.splice(old_arr.indexOf(v[0]), 1);
              setFilterValue([...old_arr]);
              if (!!setEnterPressed) setEnterPressed(true);
            } else {
              setFilterValue([
                ...filterValue,
                v[0]
              ]);
              if (!!setEnterPressed) setEnterPressed(true);
            }
          }}
          sx={{
            marginLeft: 1,
            backgroundColor: filterValue.indexOf(v[0]) > -1 ? 'white' : 'grey'
          }}
        />

        {/* <StyledButton
          label={v[1]}
          contained={filterValue.indexOf(v[0]) > -1}
          // secondary={filterValue.indexOf(v[0]) < 0}
          id='filter_true_false_no'
          onClick={(vv) => {
            if (filterValue.indexOf(v[0]) > -1) {
              let old_arr = [...filterValue];
              old_arr.splice(old_arr.indexOf(v[0]), 1);
              setFilterValue([...old_arr]);
              if (!!setEnterPressed) setEnterPressed(true);
            } else {
              setFilterValue([
                ...filterValue,
                v[0]
              ]);
              if (!!setEnterPressed) setEnterPressed(true);
            }
          }}
          sx={{width: '100%'}}
        /> */}
      {/* </Grid> */}
    </>)}
    </Grid>
    <Grid item xs={4} sx={{textAlign: 'right'}}></Grid>
    {values.slice(4, 7).map(v => <>
      <Grid item xs={2}>
        <StyledButton
          label={v[1]}
          contained={filterValue.indexOf(v[0]) > -1}
          // secondary={filterValue.indexOf(v[0]) < 0}
          id='filter_true_false_no'
          onClick={(vv) => {
            if (filterValue.indexOf(v[0]) > -1) {
              let old_arr = [...filterValue];
              old_arr.splice(old_arr.indexOf(v[0]), 1);
              setFilterValue([...old_arr]);
              if (!!setEnterPressed) setEnterPressed(true);
            } else {
              setFilterValue([
                ...filterValue,
                v[0]
              ]);
              if (!!setEnterPressed) setEnterPressed(true);
            }
          }}
          sx={{width: '100%'}}
        />
      </Grid>
    </>)}
  </>);
}